exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-keyword-review-date[data-v-1f775f6a]{position:absolute;top:2px;left:120px}", ""]);

// exports
